module.exports = __webpack_public_path__ + "static/media/hot_wxhnc.b504c760.png";